export default __webpack_public_path__ + "static/media/hyperlink_url_web_icon.0feefe1d.svg";